import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CrownStrikethroughIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="crownStrikethrough" ref={ref} {...props}>
    <path d="M12.05,9.32a.68.68,0,0,1-.12.12l0,0,.1-.09Zm3.4-4.46a.75.75,0,0,0-1.06,0L11.51,7.73,9.31,5a.78.78,0,0,0-.7-.27A.76.76,0,0,0,8,5.19L6.28,9.54,3.47,7.73a.74.74,0,0,0-.84,0,.76.76,0,0,0-.3.79L3.94,15a.76.76,0,0,0,.73.57.57.57,0,0,0,.18,0,.75.75,0,0,0,.55-.9L4.25,10l2,1.28a.78.78,0,0,0,.63.09.74.74,0,0,0,.47-.44l1.61-4,1.89,2.32a.47.47,0,0,0,.09.12.62.62,0,0,0,.22.15.44.44,0,0,0,.15.05l.16,0a.75.75,0,0,0,.43-.13l.1-.09.07-.06v0l3.39-3.38A.74.74,0,0,0,15.45,4.86Zm6.22,3.67-2,8.45v0c-.26,2.06-5.39,2.29-7.63,2.29a21,21,0,0,1-5.6-.63L3.59,21.47a.73.73,0,0,1-.53.22.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06L20.41,2.54a.74.74,0,0,1,1.06,0,.75.75,0,0,1,0,1.06L17.09,8l.63,1.56,2.81-1.81a.74.74,0,0,1,.84,0A.75.75,0,0,1,21.67,8.53Zm-3.56,8.28c-.47-.55-3.13-1.49-6.11-1.49a15.89,15.89,0,0,0-2.46.2l-1.9,1.9a22.43,22.43,0,0,0,4.36.37C15.65,17.79,17.68,17.19,18.11,16.81ZM19.77,10l-2,1.29a.71.71,0,0,1-.63.09.74.74,0,0,1-.47-.44l-.73-1.81-4.72,4.71.78,0a14.15,14.15,0,0,1,6.5,1.45Z" />
  </Icon>
)) as IconWithRender;

CrownStrikethroughIcon.displayName = 'CrownStrikethroughIcon';
CrownStrikethroughIcon.renderIcon = (props) => (
  <CrownStrikethroughIcon {...props} />
);
export default CrownStrikethroughIcon;
